<template>
<div
>
    <a
        v-on:click="onClickQuestion"
    >
        <slot name="question"></slot>
    </a>
    
    <!--<b>Answer</b>
    <slot name="answer"></slot>
    <br/><br/>-->

    <v-dialog
        v-model="dialog"
        max-width="920"
    >
        <v-card>
            <v-card-title>Frequently Asked Question</v-card-title>

            <v-card-text>
                <div class="question">Question</div>
                <div class="question-text"><slot name="question"></slot></div>
                
                <div class="answer">Answer</div>
                <div class="question-text"><slot name="answer"></slot></div>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    color="primary darken-1"
                    text
                    @click="onOk"
                >
                Ok
                </v-btn>

            </v-card-actions>

        </v-card>
    </v-dialog>
    
</div>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
        }
    },

    methods: {

        onClickQuestion()
        {
            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
        },
    },
}
</script>

<style lang="scss" scoped>
.question,
.answer
{
    font-weight: bold;
    margin-top: 8px;
}

.question-text,
.answer-text
{
    margin-left: 15px;
    margin-bottom: 8px;
}
</style>

